import { BacksolveSourceRow } from 'api/models/BacksolveSourceRow';
import { BacksolveApproachAttributes } from 'pages/ValuationsAllocation/types';
import { createColumns } from './createColumns';
import { SourceTableData } from './customParser/types';
import { customRowConfig } from './customRowConfig';
import getVisibleSourceRows from './getVisibleSourceRows';

type SourceRowsSheetLike = {
  reset: (params: {
    rowConfig?: unknown;
    columns?: unknown;
    tableData?: SourceTableData;
  }) => void;
  tableData: SourceTableData | object;
};

type ResetSourceRowsSheetParams = {
  sourceRowsSheet: SourceRowsSheetLike;
  rows: BacksolveSourceRow[];
  isDisabled: boolean;
  companyOverviewUrl?: string;
  fieldAttributes?: BacksolveApproachAttributes;
};

const resetSourceRowsSheet = ({
  sourceRowsSheet,
  rows,
  isDisabled,
  companyOverviewUrl,
  fieldAttributes,
}: ResetSourceRowsSheetParams) => {
  const visibleRows = getVisibleSourceRows(rows, isDisabled);
  const rowConfig = customRowConfig({ rows: visibleRows, isDisabled });
  const columns = createColumns({ rows: visibleRows });

  sourceRowsSheet.reset({
    rowConfig,
    columns,
    tableData: {
      ...(sourceRowsSheet.tableData as SourceTableData),
      sourceRows: visibleRows,
      isDisabled,
      companyOverviewUrl,
      fieldAttributes,
    },
  });
};

export default resetSourceRowsSheet;
